// Loom's LotDetail is the superset shape for this table's columns/labels - the Grower Gateway
// schema omits the staff-only `comment` field entirely (NZM-2136), and that column is filtered
// out at render time via `columnsForRemovalInReducedView` in lot-details-table.tsx.
import { LotDetail } from '@loom-api-types'

type LotDetailTableData = Omit<LotDetail, '__typename' | 'sale' | 'season'>
export type LotDetailProperty = keyof LotDetailTableData

// This is in the same order as the columns in the lot details table
export const lotDetailsColumnLabels: Record<LotDetailProperty, string> = {
  referenceNumber: 'Reference',
  description: 'Description',
  bales: 'Bales',
  netKgs: 'Net Kg',
  lineNumber: 'Line No',
  saleAndSeason: 'Sale / Season',
  purchaseAccountName: 'P Acc Name',
  coreTestMicron: 'Mic',
  coreTestVegetableMatterBase: 'VM',
  coreTestYield: 'YLD',
  coreTestColourYZ: 'Col',
  coreTestStapleLengthGreasy: 'SL',
  coreTestStapleStrength: 'SS',
  type: 'Type',
  comment: 'Comment',
  result: 'Result',
  priceGreasy: 'Price Greasy',
  priceClean: 'Price Clean',
  code: 'Lot No',
  cleanKgs: 'Clean Kg',
  coreTestCoefficientOfVariationLaserscan: 'LS CV',
  coreTestStapleAverageStrength: 'SS25',
  coreTestPointOfBreakTip: 'POBt',
  coreTestPointOfBreakMid: 'POBm',
  coreTestPointOfBreakBase: 'POBb',
  grossProceeds: 'Gross Proceeds',
  paymentDate: 'Payment Date',
  coreTestMicronLaserscan: 'Laser',
  coreTestMicronOfda: 'Ofda',
  coreTestMicronAirflow: 'Airflow',
  weighDate: 'Weight Date',
  lottedDate: 'Lotted Date',
  qualityScheme2: 'ZQ/RX',
  recordType: 'Record',
  sample: 'Sample',
  saleAccount: 'Sale Account',
}

export const convertLotDetailKeysToLabels = (
  lotDetails: LotDetail[]
): Record<LotDetailProperty, any>[] => {
  const convertedDetails: Record<LotDetailProperty, any>[] = []
  lotDetails.forEach((lotDetail) => {
    const converted: Record<string, any> = {}
    // Convert keys using the keyToLabelMap so that the CSV header matches the table header
    Object.keys(lotDetailsColumnLabels).forEach((key) => {
      converted[lotDetailsColumnLabels[key as LotDetailProperty]] =
        lotDetail[key as LotDetailProperty]
    })
    convertedDetails.push(converted)
  })
  return convertedDetails
}
